import React, { useEffect, useState } from 'react'

import { getActividades } from '../services/ActividadesService';

import ModalesActividades from '../components/Modales/ModalesActividades'
import Actividad from '../models/Actividad';

type Props = {}

const Actividades = (props: Props) => {

    var tituloSeccion: string = "Actividades";

    const [actividades, setActividades] = useState<Actividad[]>([]);

    useEffect(() => {
        setActividades(getActividades())
    }, []);

    const pintarItemActividad = () => {

        return actividades.map((actividad: Actividad, index: number) => {
                return (
                    <div className="col-md-6 col-lg-4 mb-5" key={index}>
                        <div className="seccionBlanca-item mx-auto" data-bs-toggle="modal" data-bs-target={ '#' + actividad.idModal }>
                            <div className="seccionBlanca-item-caption d-flex align-items-center justify-content-center h-100 w-100">
                                <div className="seccionBlanca-item-caption-content text-center text-white">
                                    <i className="fas fa-plus fa-3x"></i>
                                </div>
                            </div>
                            <img className="img-fluid habitacion" src={ actividad.imagenes[0].path } alt={ actividad.titulo } />
                            <p className='text-center fw-bolder mt-3'>{ actividad.titulo }</p>
                        </div>
                    </div>
                )
            })

    }

    return (
        <>
        <section className="page-section seccionBlanca" id="actividades">
            <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">{ tituloSeccion }</h2>
                
                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                    <i className="fa-solid fa-person-walking"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row justify-content-center">
                    <p className='textoJustificado'>
                        Griegos ofrece una gran variedad de actividades las cuales nos van a permitir disfrutar y conocer el entorno privilegiado del que disponemos. Te invitamos a que recorras sus frondosos bosques, explores sus nacimientos naturales de agua, te sorprendas por el avistamiento de algún animal o descubras sus numerosas variedades de setas que crecen por sus alrededores.
                    </p>
                </div>

                <div className="row justify-content-center">

                    {
                        pintarItemActividad()
                    }
                    
                </div>

                <div className="row justify-content-center">

                    <p className='textoJustificado'>
                        Si estás interesado en conocer todo nuestro entorno, a traves de diferentes rutas podras recorrer y conocer los entornos que nos rodean. Te invitamos que consultes los siguientes enlaces para obtener más información.
                    </p>
                   
                    <a className="btn btn-outline-primary btn-enlace-actividades mx-1" target="_blank" rel="noreferrer" href="https://es.wikiloc.com/wikiloc/user.do?id=10344486">
                        <img src='img/icons/wikiloc.png' className='me-2' alt='icono Wikiloc TurismoGriegos'/>
                        <i className="fa-solid fa-route"></i>
                    </a>

                    <a className="btn btn-outline-secondary btn-enlace-actividades mx-1" target="_blank" rel="noreferrer" href="https://es.wikiloc.com/rutas/senderismo/espana/aragon/griegos">
                        <img src='img/icons/wikiloc.png' className='me-2' alt='icono Wikiloc Griegos'/>
                        <i className="fa-solid fa-route"></i>
                    </a>
                    
                </div>

            </div>

            <ModalesActividades actividades={actividades} />

        </section>

        </>
        
    )
}

export default Actividades